import { ScrollTop } from '@/components/element/ScrollTop';
import { PaymentTaskExpenseAccountItemEditForm } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskExpenseAccountItemEditForm';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const BackofficePaymentTaskExpenseAccountItems = () => {
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { purchase_order_id } = useParams();
  const { paymentTask: task } = useCurrentPaymentTask();
  useEffect(() => setTitle(`費用科目の分類`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `支払タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/payment_tasks` },
        {
          label: `支払タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/purchase_orders/${purchase_order_id}/payment_tasks/${
            task!.id
          }`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <PaymentTaskExpenseAccountItemEditForm />
    </WorkspaceLayout>
  );
};
